import { render, staticRenderFns } from "./CoozzyFormTextarea.vue?vue&type=template&id=48c57a92&scoped=true"
import script from "./CoozzyFormTextarea.vue?vue&type=script&lang=js"
export * from "./CoozzyFormTextarea.vue?vue&type=script&lang=js"
import style0 from "./CoozzyFormTextarea.vue?vue&type=style&index=0&id=48c57a92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48c57a92",
  null
  
)

export default component.exports